import { FieldHookConfig, useField } from 'formik';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';

import { Checkbox, CheckboxProps } from '../../../components/Checkbox';

interface FormCheckboxExtraProps {
  name: string;
}

type FormCheckboxProps = CheckboxProps &
  FormCheckboxExtraProps &
  FieldHookConfig<boolean>;

export const FormCheckbox: React.FC<FormCheckboxProps> = (props) => {
  const [field, meta, helpers] = useField(props);
  const { setValue } = helpers;
  const { onChange } = props;

  return (
    <Stack spacing={0.5}>
      <Checkbox
        {...field}
        size="small"
        checked={field.value}
        {...props}
        onChange={(event) => {
          setValue(event.target.checked);
          if (onChange) onChange(event, event.target.checked);
        }}
      />
      {meta.touched && meta.error && (
        <Typography variant="caption" color="error">
          {meta.error}
        </Typography>
      )}
    </Stack>
  );
};
